import WhiteLogo from '@/shared/ui/WhiteLogo';
import { CreditCard, Home, Instagram, Settings, AutoAwesome, Insights, Schedule, Forum } from '@mui/icons-material';
import { Box } from '@mui/material';
import { ReactNode, useMemo } from 'react';
import SidebarItem from './SidebarItem';
import { useMe } from '@/features/auth';
import { formatDuration } from '@/shared/lib/utils';

export type TSidebarItem = {
    display: string | ReactNode;
    icon: ReactNode;
    path: string;
    section: string;
    active: boolean;
    allwaysActive: boolean;
};

const SidebarItems = () => {
    const { data: meResponse } = useMe();

    const userData = meResponse?.data?.success ? meResponse.data.data : null;
    const activePlanName = userData?.plan?.name;

    const mainMenuItems: TSidebarItem[] = useMemo(
        () => [
            {
                display: 'Dashboard',
                icon: <Home className="w-6 h-6 text-white" />,
                path: '/',
                section: 'dashboard',
                active: true,
                allwaysActive: false,
            },
            {
                display: 'Automations',
                icon: <AutoAwesome className="w-6 h-6 text-white" />,
                path: '/automations',
                section: 'automations',
                active: true,
                allwaysActive: false,
            },
            {
                display: 'Manage Messages',
                icon: <Forum className="w-6 h-6 text-white" />,
                path: '/messages',
                section: 'messages',
                active: true,
                allwaysActive: false,
            },
            {
                display: 'Insight Analysis',
                icon: <Insights className="w-6 h-6 text-white" />,
                path: '/insights',
                section: 'insights',
                active: true,
                allwaysActive: false,
            },
            {
                display: 'Schedule Content',
                icon: <Schedule className="w-6 h-6 text-white" />,
                path: '/scheduled-content',
                section: 'scheduled-content',
                active: true,
                allwaysActive: false,
            },
            {
                display: 'Accounts',
                icon: <Instagram className="w-6 h-6 text-white" />,
                path: '/accounts',
                section: 'accounts',
                active: true,
                allwaysActive: false,
            },
            {
                display: activePlanName ? (
                    <span className="flex items-center w-full justify-between">
                        Plans
                        <span className="p-1 text-xs bg-white rounded-xl px-3">{activePlanName}</span>
                    </span>
                ) : (
                    'Plans'
                ),
                icon: <CreditCard className="w-6 h-6 text-primary" />,
                path: '/plans',
                section: 'plans',
                active: true,
                allwaysActive: true,
            },
            {
                display: 'Settings',
                icon: <Settings className="w-6 h-6 text-white" />,
                path: '/settings',
                section: 'settings',
                active: true,
                allwaysActive: false,
            },
        ],
        [activePlanName]
    );

    return (
        <Box>
            <Box className="mt-20 md:mt-4 md:mb-2 flex flex-col justify-center items-center gap-2">
                <Box
                    sx={{
                        px: '10px',
                        py: '10px',
                        width: '160px',
                    }}
                >
                    <WhiteLogo />
                </Box>
                {userData?.plan ? (
                    <div className="md:hidden flex items-center px-2 py-1 gap-1 rounded-md border border-white/40 text-sm text-white">
                        <span>{userData.plan.name}</span>/
                        <span className="text-primary-light">
                            {userData.plan.expired_time
                                ? formatDuration(Date().toString(), userData.plan.expired_time)
                                : 'No expiration'}
                        </span>
                    </div>
                ) : (
                    <div className="md:hidden flex items-center px-2 py-1 gap-1 rounded-md border border-white/40 text-sm">
                        <span className="text-primary">Your plan expired</span>
                    </div>
                )}
            </Box>
            <SidebarItem items={mainMenuItems} />
        </Box>
    );
};

export default SidebarItems;
